// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OsvrtiNaVoditelja_text__tVK49 {
  font-weight: 500;
  color: #4d4d4d;
  width: 100%;
  max-width: 800px;
}
.OsvrtiNaVoditelja_containerVoditelj__DbX-I {
  width: 30%;
  margin-top: 30px;
}
.OsvrtiNaVoditelja_containerBio__fDZnX {
  margin-top: 20px;
  width: 100%;
  max-width: 800px;
}
.OsvrtiNaVoditelja_bioTitle__ZbXsD {
  color: #828d9a;
  font-weight: 600;
}
.OsvrtiNaVoditelja_text__tVK49,
.OsvrtiNaVoditelja_bioTitle__ZbXsD,
.OsvrtiNaVoditelja_textarea__xRQby,
.OsvrtiNaVoditelja_starLabel__ur\\+jh,
.OsvrtiNaVoditelja_radioTitle__TiruK,
.OsvrtiNaVoditelja_radioLabel__T-TRa {
  font-family: "Inter";
  font-size: 16px;
  font-style: normal;
  line-height: 22px;
  letter-spacing: -0.016px;
}
.OsvrtiNaVoditelja_textarea__xRQby {
  width: 100%;
  height: 130px;
  border-radius: 8px;
  border: 1px solid #d8dbdf;
  background: #ffffff;
  background-origin: border-box;
  background-clip: content-box, border-box;
  color: #828d9a;
  font-weight: 500;
  padding: 10px;
  resize: none;
  box-sizing: border-box;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
}
.OsvrtiNaVoditelja_textarea__xRQby:focus {
  border: 1px solid #cb9c2d !important;
  outline: none !important;
}
.OsvrtiNaVoditelja_textarea__xRQby:hover {
  border: 1px solid #cb9c2d;
}
.OsvrtiNaVoditelja_ratingsContainer__bf\\+zS {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 800px;
  gap: 30px;
  margin-top: 30px;
  text-align: center;
}
.OsvrtiNaVoditelja_ratingContainer__0J0Fi {
  border-radius: 8px;
  border: 1px solid #d8dbdf;
  padding: 10px 20px;
  justify-content: center;
}
.OsvrtiNaVoditelja_ratingContainer__0J0Fi,
.OsvrtiNaVoditelja_radioContainer__WBgMp {
  display: flex;
  flex-direction: column;
}
.OsvrtiNaVoditelja_starLabel__ur\\+jh {
  color: #5f6d7e;
  font-weight: 600;
  margin-bottom: 10px;
  white-space: normal;
  max-width: 600px;
}
.OsvrtiNaVoditelja_btns__x3ctj {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.OsvrtiNaVoditelja_evaluationItem__n263I {
  display: flex;
  max-height: 30px;
}
.OsvrtiNaVoditelja_starContainer__ROxnS {
  width: 100%;
}
.OsvrtiNaVoditelja_starContainer__ROxnS,
.OsvrtiNaVoditelja_buttonContainer__tFYDJ {
  justify-content: center;
  display: flex;
  margin-bottom: 24px;
}
.OsvrtiNaVoditelja_radioContainer__WBgMp {
  margin-top: 30px;
  width: 100%;
  max-width: 800px;
}
.OsvrtiNaVoditelja_radioLabel__T-TRa {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.OsvrtiNaVoditelja_customRadio__DjZpy {
  color: #e2e2e2;
}
.OsvrtiNaVoditelja_customRadioChecked__MMlEI {
  color: #cb9c2d !important;
}
.OsvrtiNaVoditelja_radioTitle__TiruK,
.OsvrtiNaVoditelja_radioLabel__T-TRa {
  color: #5f6d7e;
  text-align: left;
  font-weight: 600;
}
.OsvrtiNaVoditelja_radioTitle__TiruK {
  margin-top: 30px;
}
.OsvrtiNaVoditelja_radioBox__Jc5x8 {
  display: flex;
  flex-direction: row;
}
.OsvrtiNaVoditelja_buttonContainer__tFYDJ {
  width: 100%;
  max-width: 800px;
  padding: 10px;
  gap: 20px;
  margin-top: 20px;
}
.OsvrtiNaVoditelja_cancelButton__cCFIb {
  background: #ebebeb;
  color: #808080;
}
.OsvrtiNaVoditelja_cancelButton__cCFIb,
.OsvrtiNaVoditelja_nextButton__7LLAp {
  width: 212px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  transition: background-color 300ms ease-in-out;
}
.OsvrtiNaVoditelja_cancelButton__cCFIb:hover,
.OsvrtiNaVoditelja_nextButton__7LLAp:hover {
  cursor: pointer;
}
.OsvrtiNaVoditelja_cancelButton__cCFIb:hover {
  background-color: #c2c1c1;
}
.OsvrtiNaVoditelja_nextButton__7LLAp:hover {
  background-color: #b68b29;
}
.OsvrtiNaVoditelja_nextButton__7LLAp {
  background: #cb9c2d;
  color: #ffffff;
}

.OsvrtiNaVoditelja_title__1xKXj {
  font-family: "Inter";
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
  margin-bottom: 20px;
}

.OsvrtiNaVoditelja_evaluationContainer__r0bE2 {
  margin-top: 50px;
}

.OsvrtiNaVoditelja_evaluationTitle__HOmaB,
.OsvrtiNaVoditelja_evaluationDescription__HhGPG {
  font-family: "Inter";
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
  margin-block-end: 10px;
  margin-block-start: 5px;
}

.OsvrtiNaVoditelja_evaluationText__K-Hu9 {
  margin-bottom: 30px;
}

.OsvrtiNaVoditelja_evaluationNumber__0g\\+Yh {
  margin: 40px 0;
}

.OsvrtiNaVoditelja_evaluationDescription__HhGPG {
  font-weight: 500;
  font-size: 16px;
}

.OsvrtiNaVoditelja_evaluationBtnsContainer__tINrN {
  border: 1px solid #d1d9e2;
  max-width: 600px;
  min-width: 600px;
  padding: 16px 24px;
  box-sizing: border-box;
  border-radius: 10px;
}

.OsvrtiNaVoditelja_evaluationItemsContainer__9xEpp {
  display: flex;
  gap: 40px;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.OsvrtiNaVoditelja_evaluationItemsContainer__9xEpp::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

@media screen and (max-width: 1300px) {
  .OsvrtiNaVoditelja_textarea__xRQby {
    box-shadow: 4px 4px 35px 0px rgba(95, 109, 126, 0.1);
  }
}
@media screen and (max-width: 630px) {
  .OsvrtiNaVoditelja_ratingContainer__0J0Fi {
    height: 100px;
    padding: 10px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/OsvrtiNaVoditelja/OsvrtiNaVoditelja.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;EAME,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;AACtD;AACA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;;EAEE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;AACA;;EAEE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;AACA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;AACF","sourcesContent":[".text {\n  font-weight: 500;\n  color: #4d4d4d;\n  width: 100%;\n  max-width: 800px;\n}\n.containerVoditelj {\n  width: 30%;\n  margin-top: 30px;\n}\n.containerBio {\n  margin-top: 20px;\n  width: 100%;\n  max-width: 800px;\n}\n.bioTitle {\n  color: #828d9a;\n  font-weight: 600;\n}\n.text,\n.bioTitle,\n.textarea,\n.starLabel,\n.radioTitle,\n.radioLabel {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-style: normal;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n.textarea {\n  width: 100%;\n  height: 130px;\n  border-radius: 8px;\n  border: 1px solid #d8dbdf;\n  background: #ffffff;\n  background-origin: border-box;\n  background-clip: content-box, border-box;\n  color: #828d9a;\n  font-weight: 500;\n  padding: 10px;\n  resize: none;\n  box-sizing: border-box;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n}\n.textarea:focus {\n  border: 1px solid #cb9c2d !important;\n  outline: none !important;\n}\n.textarea:hover {\n  border: 1px solid #cb9c2d;\n}\n.ratingsContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 800px;\n  gap: 30px;\n  margin-top: 30px;\n  text-align: center;\n}\n.ratingContainer {\n  border-radius: 8px;\n  border: 1px solid #d8dbdf;\n  padding: 10px 20px;\n  justify-content: center;\n}\n.ratingContainer,\n.radioContainer {\n  display: flex;\n  flex-direction: column;\n}\n.starLabel {\n  color: #5f6d7e;\n  font-weight: 600;\n  margin-bottom: 10px;\n  white-space: normal;\n  max-width: 600px;\n}\n.btns {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.evaluationItem {\n  display: flex;\n  max-height: 30px;\n}\n.starContainer {\n  width: 100%;\n}\n.starContainer,\n.buttonContainer {\n  justify-content: center;\n  display: flex;\n  margin-bottom: 24px;\n}\n.radioContainer {\n  margin-top: 30px;\n  width: 100%;\n  max-width: 800px;\n}\n.radioLabel {\n  display: flex;\n  align-items: center;\n  margin-right: 20px;\n}\n.customRadio {\n  color: #e2e2e2;\n}\n.customRadioChecked {\n  color: #cb9c2d !important;\n}\n.radioTitle,\n.radioLabel {\n  color: #5f6d7e;\n  text-align: left;\n  font-weight: 600;\n}\n.radioTitle {\n  margin-top: 30px;\n}\n.radioBox {\n  display: flex;\n  flex-direction: row;\n}\n.buttonContainer {\n  width: 100%;\n  max-width: 800px;\n  padding: 10px;\n  gap: 20px;\n  margin-top: 20px;\n}\n.cancelButton {\n  background: #ebebeb;\n  color: #808080;\n}\n.cancelButton,\n.nextButton {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  transition: background-color 300ms ease-in-out;\n}\n.cancelButton:hover,\n.nextButton:hover {\n  cursor: pointer;\n}\n.cancelButton:hover {\n  background-color: #c2c1c1;\n}\n.nextButton:hover {\n  background-color: #b68b29;\n}\n.nextButton {\n  background: #cb9c2d;\n  color: #ffffff;\n}\n\n.title {\n  font-family: \"Inter\";\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n  margin-bottom: 20px;\n}\n\n.evaluationContainer {\n  margin-top: 50px;\n}\n\n.evaluationTitle,\n.evaluationDescription {\n  font-family: \"Inter\";\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n  margin-block-end: 10px;\n  margin-block-start: 5px;\n}\n\n.evaluationText {\n  margin-bottom: 30px;\n}\n\n.evaluationNumber {\n  margin: 40px 0;\n}\n\n.evaluationDescription {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.evaluationBtnsContainer {\n  border: 1px solid #d1d9e2;\n  max-width: 600px;\n  min-width: 600px;\n  padding: 16px 24px;\n  box-sizing: border-box;\n  border-radius: 10px;\n}\n\n.evaluationItemsContainer {\n  display: flex;\n  gap: 40px;\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.evaluationItemsContainer::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n\n@media screen and (max-width: 1300px) {\n  .textarea {\n    box-shadow: 4px 4px 35px 0px rgba(95, 109, 126, 0.1);\n  }\n}\n@media screen and (max-width: 630px) {\n  .ratingContainer {\n    height: 100px;\n    padding: 10px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `OsvrtiNaVoditelja_text__tVK49`,
	"containerVoditelj": `OsvrtiNaVoditelja_containerVoditelj__DbX-I`,
	"containerBio": `OsvrtiNaVoditelja_containerBio__fDZnX`,
	"bioTitle": `OsvrtiNaVoditelja_bioTitle__ZbXsD`,
	"textarea": `OsvrtiNaVoditelja_textarea__xRQby`,
	"starLabel": `OsvrtiNaVoditelja_starLabel__ur+jh`,
	"radioTitle": `OsvrtiNaVoditelja_radioTitle__TiruK`,
	"radioLabel": `OsvrtiNaVoditelja_radioLabel__T-TRa`,
	"ratingsContainer": `OsvrtiNaVoditelja_ratingsContainer__bf+zS`,
	"ratingContainer": `OsvrtiNaVoditelja_ratingContainer__0J0Fi`,
	"radioContainer": `OsvrtiNaVoditelja_radioContainer__WBgMp`,
	"btns": `OsvrtiNaVoditelja_btns__x3ctj`,
	"evaluationItem": `OsvrtiNaVoditelja_evaluationItem__n263I`,
	"starContainer": `OsvrtiNaVoditelja_starContainer__ROxnS`,
	"buttonContainer": `OsvrtiNaVoditelja_buttonContainer__tFYDJ`,
	"customRadio": `OsvrtiNaVoditelja_customRadio__DjZpy`,
	"customRadioChecked": `OsvrtiNaVoditelja_customRadioChecked__MMlEI`,
	"radioBox": `OsvrtiNaVoditelja_radioBox__Jc5x8`,
	"cancelButton": `OsvrtiNaVoditelja_cancelButton__cCFIb`,
	"nextButton": `OsvrtiNaVoditelja_nextButton__7LLAp`,
	"title": `OsvrtiNaVoditelja_title__1xKXj`,
	"evaluationContainer": `OsvrtiNaVoditelja_evaluationContainer__r0bE2`,
	"evaluationTitle": `OsvrtiNaVoditelja_evaluationTitle__HOmaB`,
	"evaluationDescription": `OsvrtiNaVoditelja_evaluationDescription__HhGPG`,
	"evaluationText": `OsvrtiNaVoditelja_evaluationText__K-Hu9`,
	"evaluationNumber": `OsvrtiNaVoditelja_evaluationNumber__0g+Yh`,
	"evaluationBtnsContainer": `OsvrtiNaVoditelja_evaluationBtnsContainer__tINrN`,
	"evaluationItemsContainer": `OsvrtiNaVoditelja_evaluationItemsContainer__9xEpp`
};
export default ___CSS_LOADER_EXPORT___;
